// AI-thread media rendering decisions (Phase A, docs/AI_MEDIA_SPEC.md).
// Mirrors the Messages tab's image detection so both views agree on what an
// attachment looks like.

const IMAGE_EXT_RE = /\.(jpg|jpeg|png|gif|webp)(\?|$)/i;

export function mediaKind(entry) {
  if (!entry) return 'file';
  const type = entry.contentType || '';
  if (/^image\//i.test(type)) return 'image';
  if (!type && IMAGE_EXT_RE.test(entry.url || '')) return 'image';
  return 'file';
}

export function messageMedia(msg) {
  return (msg && Array.isArray(msg.media)) ? msg.media : [];
}
